/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_OriginInputs */

const en_ledger_query_origin = /** @type {(inputs: Ledger_Query_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database connection`)
};

const nl_ledger_query_origin = /** @type {(inputs: Ledger_Query_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databaseverbinding`)
};

/**
* | output |
* | --- |
* | "Database connection" |
*
* @param {Ledger_Query_OriginInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_origin = /** @type {((inputs?: Ledger_Query_OriginInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_OriginInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_origin(inputs)
	return en_ledger_query_origin(inputs)
});